<template>
<nav>
    <ul v-if="totalPages>=2" class="pagination">
        <li class="page-item">
            <a class="page-link cursor-pointer" @click="changePage(currentPage-1)">
                <span>&laquo;</span>
                <span class="sr-only">Previous</span>
            </a>
        </li>
        <li v-for="page in pages" :data-test="`page-link-${page}`" :key="page" :class="paginationClass(page)" @click.prevent="changePage(page)">
            <a v-if="showPages" class="page-link" href v-text="page" />
        </li>
        <li class="page-item">
            <a class="page-link cursor-pointer" @click="changePage(currentPage+1)">
                <span>&raquo;</span>
                <span class="sr-only">Next</span>
            </a>
        </li>
    </ul>
</nav>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        count: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true,
        },
        itemsPerPage: {
            type: Number,
            required: true
        },
        showPages: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        changePage(goToPage) {
            var totalPages = Math.ceil(this.count / this.itemsPerPage);
            if (goToPage < 1 || goToPage > totalPages) {
                return;
            }
            if (goToPage === this.currentPage) return;
            this.$emit("update:currentPage", goToPage);
        },
        paginationClass(page) {
            return {
                "page-item": true,
                active: this.currentPage === page
            };
        }
    },

    computed: {

        pages() {
            var result = [];
            if (this.count <= this.itemsPerPage) {
                result;
            }

            var totalPages = Math.ceil(this.count / this.itemsPerPage);

            var start = 1;
            if (this.currentPage - 5 > 0) {
                start = this.currentPage - 5;
            }

            for (var i = start; i <= totalPages && result.length < 10; i++) {
                result.push(i);
            }

            if (result.length < 10 && totalPages > 5) {
                var start = result[0] - 1;
                for (i = start; i > 0 && result.length < 10; i--) {
                    result.unshift(i);
                }
            }

            return result;

        },

        totalPages() {
            if (this.count <= this.itemsPerPage) {
                return 0;
            }
            return Math.ceil(this.count / this.itemsPerPage);
        }
    }
};
</script>
